import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

const LABELS = {
  masterclass: 'Masterclass',
  archive: 'Archive',
  videos: 'Videos',
  gallery: 'Gallery',
  speakers: 'Speakers',
  resources: 'Resources',
  certificates: 'Certificates',
  register: 'Register',
  'verify-certificate': 'Certificates',
}

export default function Breadcrumbs({ title }) {
  const { pathname } = useLocation()
  const parts = pathname.split('/').filter(Boolean)

  // If we are on a detail page, build deeper crumbs
  const crumbs = []
  let path = ''
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i]
    path += `/${part}`
    const label = LABELS[part] || (part === 'speakers' && i > 0 ? 'Speaker' : part)
    const isLast = i === parts.length - 1
    crumbs.push({ path, label, isLast })
  }

  return (
    <nav aria-label="Breadcrumb" className="inline-flex">
      <ol className="flex flex-wrap items-center gap-2 text-xs font-sans uppercase tracking-wider text-cinema-muted">
        <li>
          <Link to="/explore" className="inline-flex items-center gap-1 hover:text-cinema-gold transition-colors">
            <Home className="w-3 h-3" />
            <span>Home</span>
          </Link>
        </li>
        {crumbs.map((crumb) => (
          <li key={crumb.path} className="flex items-center gap-2">
            <ChevronRight className="w-3 h-3" />
            {crumb.isLast ? (
              <span className="text-cinema-gold line-clamp-1 max-w-[280px]" aria-current="page">
                {title || crumb.label}
              </span>
            ) : (
              <Link to={crumb.path} className="hover:text-cinema-gold transition-colors">
                {crumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
